import React, { FC, Fragment, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetPage } from '../../hooks/useGetPage';
import RoomsSummary from './RoomsSummary';
import FlightDetails from './FlightDetails';
import SummaryCard from './SummaryDetails';
import { OphirSuccessResponse } from '../../ts/interfaces/OphirBook';
import { formatPriceCurrency, getCurrency } from '@bepro-travel/fe.utils';
import { pushDataLayer } from '../../utils';

const OphirSuccessPage: FC = () => {
  const [t] = useTranslation() as unknown as [(key: string) => string];
  const successRef = useRef<HTMLDivElement>(null);

  useGetPage('rutours/BookComplete');

  const [order, setOrder] = useState<OphirSuccessResponse>();

  useEffect(() => {
    const orderStr = sessionStorage.getItem('ophirSuccessOrder');
    if (orderStr) {
      const order = JSON.parse(orderStr);
      setOrder(order);
      pushDataLayer(order);
    }
  }, []); // eslint-disable-line

  return (
    <div className="oph-success page-wrapper" ref={successRef}>
      <div className="title">
        {t('flight.order_summary')} #{order?.data.orderId}
      </div>
      <div className="text-md mb-20">{t('success')}!</div>
      {order?.bookingSuccess && order?.creditCard && (
        <div className="text-md mb-20">{t('hotel.paid_successfully')}</div>
      )}

      {!!order && (
        <Fragment>
          <RoomsSummary rooms={order.data.roomsClasses} />
          <FlightDetails flights={order.data.deals?.[0].flights} />
          <SummaryCard deal={order.data.deals?.[0]} nights={order.data.roomsClasses?.[0].nights} />
          <div className="mb-30"></div>
          <div className="mb-30 text-bold text-md">
            {t('total_price')}:{' '}
            {formatPriceCurrency(order.data.totalPrice, getCurrency(order.data.currency))}
          </div>
        </Fragment>
      )}
    </div>
  );
};

export default OphirSuccessPage;
